import { Shared } from "../App";
import { Container, DisplayObject, Graphics, IDestroyOptions, Rectangle, Renderer, Sprite, Texture } from 'pixi.js';

export default class NativeAdPanel extends DisplayObject
{
    public view: Container;
    public sprite: Sprite;
    public sortDirty: boolean = false;
    
    private textureTargetWidth: number = 424;
    private textureTargetHeight: number = 260;
    
    constructor()
    {
        super();
        
        this.view = new Container();

        this.sprite = new Sprite();
        this.sprite.anchor.set(0.5);
        this.sprite.y = -31;
        this.view.addChild(this.sprite);
        
        let mask = new Graphics();
        mask.beginFill(0x254661);
        mask.position.set(this.sprite.x, this.sprite.y);
        mask.drawRoundedRect(-this.textureTargetWidth / 2, -this.textureTargetHeight / 2, this.textureTargetWidth, this.textureTargetHeight, 15);
        this.sprite.mask = mask;
        this.view.addChild(mask);
        
    }
    
    calculateBounds(): void {
        
    }
    
    removeChild(child: DisplayObject): void {
        
    }
    
    render(renderer: Renderer): void {
        
    }

    show(): void{
        if(Shared.ads.nativeAdLoaded && Shared.ads.bannerAdTexture){
            this.sprite.texture = Shared.ads.bannerAdTexture.clone();
            Shared.ads.recordNativeAdImpression();
        }
        else{
            this.sprite.texture = Shared.assets.getTexture('fallback_nativead');
        }
        
        let scaleX = this.textureTargetWidth / this.sprite.width;
        let scaleY = this.textureTargetHeight / this.sprite.height;
        let scale = Math.max(scaleX, scaleY);
        console.log(scaleX, scaleY, this.textureTargetHeight, this.sprite.height, this.sprite.height * scale)
        
        this.sprite.width *= scale;
        this.sprite.height *= scale;
    }
    
    hide(): void{

    }

    destroy(_options?: boolean | IDestroyOptions): void {
        super.destroy(_options);
    }

}
